// @ts-nocheck

import { CompanyNameValidator, EmailValidator, NameValidator, UrlValidator } from '@branchjs/tooling';
import { parseDomainFromEmail } from '../../../../shared/utils/parseDomainFromEmail';

// Utility file for the validations run on form in the SignupScreen.
const nameValidator: NameValidator = new NameValidator();
const firstNameValid = (name: string | null | undefined) => {
  return !!name ? nameValidator.validate(name) : false;
};

const lastNameValid = (lastName: string | null | undefined) => {
  return !!lastName ? nameValidator.validate(lastName) : false;
};

const inputTooLong = (input: string | null | undefined) => {
  if (input) {
    return input.length >= 255 ? true : false;
  }
};
const validBusinessEmail = (email: string | null | undefined) => {
  const SIGNUP_EMAIL_DOMAIN_BLOCKLIST_REGEX = (window as any).SIGNUP_EMAIL_DOMAIN_BLOCKLIST_REGEX;
  if (email) {
    const emailDomain = parseDomainFromEmail(email);
    // biome-ignore lint/suspicious/noDoubleEquals: ignored using `--suppress`
    return emailDomain == '' || SIGNUP_EMAIL_DOMAIN_BLOCKLIST_REGEX.some((pattern) => pattern.test(emailDomain))
      ? false
      : true;
  } else {
    return false;
  }
};

const emailValidator: EmailValidator = new EmailValidator();
const emailValid = (email: string | null | undefined): boolean => {
  return !!email ? emailValidator.validate(email) : false;
};

const passwordsMatch = (password: string | null | undefined, password2: string | null | undefined) => {
  return !!password && password === password2 ? true : false;
};

const roleSelected = (role: string | null | undefined) => {
  return !!role ? true : false;
};

const termsTickbox = (terms: boolean | null | undefined) => {
  return !!terms ? true : false;
};

const companyNameValidator: CompanyNameValidator = new CompanyNameValidator();
const companyNameValid = (companyName: string | null | undefined): boolean => {
  return !!companyName ? companyNameValidator.validate(companyName) : false;
};

const urlValidator: UrlValidator = new UrlValidator();
const urlValid = (url: string | null | undefined): boolean => {
  return !!url ? urlValidator.validate(url) : false;
};

export {
  firstNameValid,
  lastNameValid,
  inputTooLong,
  emailValid,
  validBusinessEmail,
  passwordsMatch,
  roleSelected,
  termsTickbox,
  companyNameValid,
  urlValid,
};
